import { render, staticRenderFns } from "./CenterViewShippingUser_Ap.vue?vue&type=template&id=64b50fae&scoped=true"
import script from "./CenterViewShippingUser_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewShippingUser_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewShippingUser_Ap.vue?vue&type=style&index=0&id=64b50fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b50fae",
  null
  
)

export default component.exports